export const ReportReadyIllustration = () => (
  <svg
    aria-hidden
    className="h-[120px] w-[200px]"
    data-testid="report-ready-illustration-generic"
    fill="none"
    viewBox="0 0 200 120"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_5046_163593)">
      <rect fill="white" height="103.278" rx="8" width="76.2851" x="56" y="8" />
    </g>
    <path
      d="M63.5967 96.3534C63.774 93.5166 64.8732 88.3749 67.8519 90.5025C71.5752 93.162 71.0433 99.5444 68.9157 96.3534C67.2136 93.8005 63.5967 91.7439 62.001 91.0347L76.3623 93.6942"
      stroke="var(--theme-primary-light, #e8f4fe)"
      strokeLinecap="round"
    />
    <path
      d="M62.0001 66.1699C62.0001 65.2886 62.7145 64.5742 63.5958 64.5742H123.404C124.286 64.5742 125 65.2886 125 66.1699C125 67.0512 124.286 67.7656 123.404 67.7656H63.5958C62.7145 67.7656 62.0001 67.0512 62.0001 66.1699Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.0001 71.4844C62.0001 70.6031 62.7145 69.8887 63.5958 69.8887H123.404C124.286 69.8887 125 70.6031 125 71.4844C125 72.3657 124.286 73.0801 123.404 73.0801H63.5958C62.7145 73.0801 62.0001 72.3657 62.0001 71.4844Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.0001 76.8047C62.0001 75.9234 62.7145 75.209 63.5958 75.209H123.404C124.286 75.209 125 75.9234 125 76.8047C125 77.686 124.286 78.4004 123.404 78.4004H63.5958C62.7145 78.4004 62.0001 77.686 62.0001 76.8047Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62 82.123C62 81.2418 62.7144 80.5273 63.5957 80.5273H86.9993C87.8806 80.5273 88.595 81.2418 88.595 82.123C88.595 83.0043 87.8806 83.7188 86.9993 83.7188H63.5957C62.7144 83.7188 62 83.0043 62 82.123Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62 57C62 55.8954 62.8954 55 64 55H82.3398C83.4444 55 84.3398 55.8954 84.3398 57V58.319C84.3398 59.4236 83.4444 60.319 82.3398 60.319H64C62.8954 60.319 62 59.4236 62 58.319V57Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62 33.7441C62 32.8629 62.7144 32.1484 63.5957 32.1484L123.404 32.1484C124.286 32.1484 125 32.8629 125 33.7441C125 34.6254 124.286 35.3398 123.404 35.3398H63.5957C62.7144 35.3398 62 34.6254 62 33.7441Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62 39.0645C62 38.1832 62.7144 37.4688 63.5957 37.4688L123.404 37.4688C124.286 37.4688 125 38.1832 125 39.0645C125 39.9457 124.286 40.6602 123.404 40.6602H63.5957C62.7144 40.6602 62 39.9457 62 39.0645Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62 44.3828C62 43.5015 62.7144 42.7871 63.5957 42.7871L108.404 42.7871C109.286 42.7871 110 43.5015 110 44.3828C110 45.2641 109.286 45.9785 108.404 45.9785H63.5957C62.7144 45.9785 62 45.2641 62 44.3828Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62 24.5742C62 23.4696 62.8954 22.5742 64 22.5742H82.3398C83.4444 22.5742 84.3398 23.4696 84.3398 24.5742V25.8932C84.3398 26.9978 83.4444 27.8932 82.3398 27.8932H64C62.8954 27.8932 62 26.9978 62 25.8932V24.5742Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <g filter="url(#filter1_d_5046_163593)">
      <rect fill="var(--theme-success, #27ae60)" height="24" rx="12" width="24" x="120.5" y="48" />
      <path d="M137.5 57L130.625 64L127.5 60.8182" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </g>
    <defs>
      <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="115.278" id="filter0_dd_5046_163593" width="88.2852" x="50" y="4">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.184314 0 0 0 0 0.235294 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_5046_163593" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.184314 0 0 0 0 0.235294 0 0 0 0.08 0" />
        <feBlend in2="effect1_dropShadow_5046_163593" mode="normal" result="effect2_dropShadow_5046_163593" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_5046_163593" mode="normal" result="shape" />
      </filter>
      <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="28" id="filter1_d_5046_163593" width="28" x="118.5" y="47">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.184314 0 0 0 0 0.235294 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_5046_163593" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_5046_163593" mode="normal" result="shape" />
      </filter>
    </defs>
  </svg>
)
